import { date, object, string } from "yup";

export enum PaymentDetailsStepInputFields {
  PaymentDescription = "paymentDescription",
  ScheduledPaymentProcessDate = "scheduledPaymentProcessDate",
  MakerNote = "makerNote",
}

export type InitialValues = {
  [PaymentDetailsStepInputFields.PaymentDescription]: string;
  [PaymentDetailsStepInputFields.ScheduledPaymentProcessDate]: Date | null;
  [PaymentDetailsStepInputFields.MakerNote]: string;
};

export const PaymentDetailsInputObject = (positionsExcluded: boolean) =>
  object().shape({
    [PaymentDetailsStepInputFields.PaymentDescription]: string().max(
      35,
      "Must be at most 35 characters",
    ),
    [PaymentDetailsStepInputFields.ScheduledPaymentProcessDate]: date().required(
      "A payment process date is required",
    ),
    [PaymentDetailsStepInputFields.MakerNote]: positionsExcluded
      ? string()
          .trim()
          .required("Notes for reviewer are required when positions are excluded")
          .max(250, "Must be at most 250 characters")
      : string().max(250, "Must be at most 250 characters"),
  });
